import {
  FetchUserTagsOptions,
  useFetchUserTags,
} from '@modules/userTags/hooks/useFetchUserTags';
import { useCallback } from 'react';
import { QueryStatus, IsLoading } from 'v2/core/repository/edge-server/types';

function useHasUserTag<T extends string>(options?: FetchUserTagsOptions) {
  const { tags, status } = useFetchUserTags(options);

  const hasTag = useCallback(
    (tag: T): boolean => {
      if (status !== QueryStatus.SUCCESS_COMPLETED || tags.length === 0) {
        return false;
      }
      return tags.includes(tag);
    },
    [status, tags],
  );

  return {
    tags,
    hasTag,
    status,
    isLoading: IsLoading(status),
  };
}

export default useHasUserTag;
